const wholeMagnitudeFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatCraneMagnitude = (
  value: number | string | null | undefined,
  fallback = "-",
) => {
  if (value == null || value === "") return fallback;

  const numericValue =
    typeof value === "string" ? Number(value.replaceAll(",", "")) : value;

  return Number.isFinite(numericValue)
    ? wholeMagnitudeFormatter.format(numericValue)
    : fallback;
};

export const normalizeCraneMagnitudeInput = (value: string) =>
  value.replace(/[^0-9]/g, "").replace(/^0+(?=\d)/, "");

export const parseCraneMagnitude = (value: string) => {
  const normalizedValue = normalizeCraneMagnitudeInput(value);
  if (normalizedValue === "") return null;

  const numericValue = Number(normalizedValue);
  return Number.isFinite(numericValue) ? numericValue : null;
};
